import Reporting from "./Reporting.container";

export default Reporting;
